import { z } from "zod";
export const automationSchema = z.object({
    PK: z.string(),
    SK: z.string(),
    GSI1_PK: z.string(),
    GSI1_SK: z.string(),
    name: z.string(),
    type: z.string(),
    description: z.string(),
    enabled: z.boolean(),
    emailDocJson: z.any().optional(),
    emailDocMjml: z.string().optional(),
    emailSubject: z.string().optional(),
});
// export type Automation = {
//   PK: string;
//   SK: string;
//   GSI1_PK: "AUTOMATIONS";
//   GSI1_SK: string;
//   name: string;
//   type: "VOTER-REWARDS" | "CLAIM-NOMINATION";
//   description: string;
//   enabled: boolean;
//   emailDocumentObj: JSONContent;
// };
//# sourceMappingURL=types.js.map